export default __webpack_public_path__ + "static/media/manss-overlay.a94a6a57.png";